import { ListActionFactory } from '../list/list.actions'

export class EntitiesActionFactory<
  Item,
  StartPayload extends Array<any> | void = Item[],
> extends ListActionFactory<Item, StartPayload> {}
